import React, { FC, useMemo, memo } from 'react';
import _map from 'lodash/map';
import _pick from 'lodash/pick';
import DropdownWithChildren from '@minecraft.dropdown-with-children';
import { appConfig, modifiedTileSchemaValueEnum as TILE_SCHEME_VALUE } from '@minecraft.app-config';
import { useTileSchemeText } from '@blocs.common';
import { FilterData } from '../../../shared/types';

const TILE_SCHEME = _pick(TILE_SCHEME_VALUE, appConfig.enumTagKeysToShow);

type Props = FilterData;

const SelectionTag: FC<Props> = ({ name, label }) => {
  const intlTileScheme = useTileSchemeText(true);

  const tagOptions = useMemo(() => {
    const tags = Object.keys(TILE_SCHEME);

    return _map(tags, (tag) => ({
      value: TILE_SCHEME[tag],
      label: intlTileScheme[tag],
    }));
  }, []);

  return (
    <DropdownWithChildren
      withFormik
      withSelectAll
      isMultipleSelect
      name={name}
      toggleLabel={label}
      options={tagOptions}
    />
  );
};

export default memo(SelectionTag);
